import { onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import type { MenuItem } from '@cplug/frontend-core/composables'
import useStoreSyncStore from '../stores/useStoreSyncStore'
import useStoreSettingsStore from '~/domain/dashboard/store/stores/useStoreSettingsStore'

const STORE_SYNC_SIDEBAR_PATH = '/dashboard/store'

export function useStoreSyncSidebarBadge (): {
  shouldShowStoreSyncBadge: (item: MenuItem) => boolean
  } {
  const syncStore = useStoreSyncStore()
  const storeSettingsStore = useStoreSettingsStore()
  const { needsSync } = storeToRefs(syncStore)

  onMounted(() => {
    storeSettingsStore.resolveStoreAppId().then((appId) => {
      if (appId) {
        syncStore.fetchStatus(appId)
      }
    })
  })

  function shouldShowStoreSyncBadge (item: MenuItem): boolean {
    if (!needsSync.value) {
      return false
    }

    const itemPath = (item as MenuItem & { path?: string }).path ?? ''
    return itemPath === STORE_SYNC_SIDEBAR_PATH
  }

  return {
    shouldShowStoreSyncBadge
  }
}
